import DeceptionDen from "../images/deception-den.png";
import MusicImage from "../images/music.png";
import BeMoreChill from "../images/bmc.png";
import {createUseStyles} from "react-jss";
import styles from "../Style";
import useMobile from "../../../template/Mobile";
const useStyle = createUseStyles(styles)
export default function CreativeEndeavors() {
    const style = useStyle();
    const isMobile = useMobile();
    return <div>
        <div className={style.portfolioSectionHorizontalFlex}>
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3>Video Creation and Editing</h3>
                <ul>
                    <li>
                        I have made variety of videos, including but not limited to gaming videos, livestreams,
                        miniature game shows, educational videos, reviews and commentary videos.
                    </li>
                    <li>
                        I have used both VEGAS Movie Studio and Da Vinci Resolve for editing video content.
                    </li>
                    <li>
                        I have rendered and composited simple visual effects using blender, as well as used OBS to
                        display computer-generated backgrounds, animations, and transitions during livestreamed events.
                    </li>
                </ul>

            </div>
            <img src={DeceptionDen}/>
        </div>
        <div className={style.portfolioSectionHorizontalFlex}>
            { isMobile ? null : <img src={MusicImage}/> }
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3>Music Performance and Directing</h3>
                <ul>
                    <li>7 years of saxophone lessons through middle and high school</li>
                    <ul>
                        <li>Was a member of my high school's audition-only wind ensemble</li>
                    </ul>
                    <li>13 years of piano lessons</li>
                    <li>Vocal directed a charity performance for the Broadway Cares foundation at my high school</li>
                    <li>Conducted the live pit band for a student-run musical at Florida Tech</li>
                </ul>
            </div>
            { isMobile ? <img src={MusicImage}/> : null }
        </div>
        <div className={style.portfolioSectionHorizontalFlex}>
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3>Performing Arts</h3>
                <ul>
                    <li>7 years of vocal training</li>
                    <li>6 years of acting coaching</li>
                    <li>2 years of tap dance experience</li>
                    <li>3 years of jazz dance experience</li>
                    <li>I have performed in over 30 stage performances, including musicals, plays, recitals and charity
                        events.
                    </li>
                </ul>

            </div>
            <img src={BeMoreChill}/>
        </div>
    </div>
}